export default __webpack_public_path__ + "images/icons/facebook-af1255f85782e248acb2159d0d2d2bc3.svg";